export default "__VITE_ASSET__D2VzhvkI__"